import React, { useState } from "react";
import "./App.css";
import { Home } from "./Home";
import { ctx, init } from "./ctx";

function App() {
  const [state, setState] = useState(init);

  return (
    <ctx.Provider value={{
      data: state.data,
      setData: (data) => setState((prev) => ({ ...prev, data })),
    }}>
      <Home />
    </ctx.Provider>
  );
}

export default App;
